NtechApp.Clients = function($view) {
    var me = this;

    this._$view = null;
    this._touchClickEvent = null;

    this._clientsGrid = null;

    this._css = {
        ids: {
        },

        classes: {
        },

        data: {
        }
    }

    this._construct = function () {
        me._$view = $view;
        me._touchClickEvent = new NtechApp.TouchClickEvent();

        setTimeout(function() {
            if(me._$view.length == 0)
                return;

            me._createClientsGrid();
            me._bindEvents();
        }, 200);
    }

    this._bindEvents = function () {
        $(window).on(NtechApp.Clients.EVENT_DOCUMENT_RESIZE, function() {

        });

        $(document).on(NtechApp.Clients.EVENT_DOCUMENT_SCROLL, function() {
            me._clientsGrid.silentRender(me._clientsGrid.getForSilentRender(true));
        });
    }

    this._unbindEvents = function () {
        $(window).off(NtechApp.Clients.EVENT_WINDOW_RESIZE);
        $(document).off(NtechApp.Clients.EVENT_DOCUMENT_SCROLL);
    }

    this.destruct = function () {
        me._clientsGrid.destruct();

        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.Clients.EVENT_DOCUMENT_SCROLL = "scroll.NtechApp.Clients";
NtechApp.Clients.EVENT_WINDOW_RESIZE = "resize.NtechApp.Clients";

NtechApp.Clients.prototype._createClientsGrid = function() {
    this._clientsGrid = new Gridifier(this._$view.find(".grid"), {
        class: "gridItem",
        loadImages: true,
        intersections: false,
        toggle: "rotateZWithFade"
    });

    var me = this;
    this._clientsGrid.onReposition(function() {
        me._clientsGrid.silentRender(me._clientsGrid.getSilent(true));
    });

    this._clientsGrid.silentAppend(this._clientsGrid.collectNew());
};